// removed by extract-text-webpack-plugin
module.exports = {"RegisterInterest":"CompetitionForm__RegisterInterest___2aaK-","CompetitionForm":"CompetitionForm__CompetitionForm___L8zX5","CompetitionFormText":"CompetitionForm__CompetitionFormText___2W0Fv","requiredStar":"CompetitionForm__requiredStar___3_hLr"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/CompetitionForm/CompetitionForm.less
// module id = 1132
// module chunks = 0 1